import styled, { css } from 'styled-components';
import { Heading, Button, ButtonAppearance } from '@bechtel/gds';

export const AttachmentHeadingStyled = styled(Heading)`
  ${({ theme }) => css`
    flex-grow: 1;
    font-size: ${theme.fontSizes[400]};
    font-family: ${theme.fontFamilies['graphik']};
    background: ${theme.colors.grey[200]};
    padding-bottom: ${theme.spacings[500]};
    padding-left: ${theme.spacings[500]};
    padding-right: ${theme.spacings[500]};
    padding-top: ${theme.spacings[600]};
    border: solid 1px ${theme.colors.grey[300]};
    color: ${theme.colors.grey[1000]};
  `}
`;

export const FooterButtonStyled = styled(Button).attrs({ appearance: ButtonAppearance.SECONDARY })`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
    padding-right: ${theme.spacings[600]};
    padding-left: ${theme.spacings[600]};
    width: auto;
  `}
`;
